import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { httpClient } from "common/httpClient";
import UserSessions from "./UserSessions";

export default function UserSessionsWidget() {
    const [minutes, setMinutes] = useState(MINUTES[0].value);
    const sessions = useUserSessions(minutes);

    return (
        <div className="activeUsers">
            <div className="flexWidget">
                <div className="flexWidget__header">
                    <h3>Active users</h3>
                    <select id="user-sessions-minutes" value={minutes} onChange={(e) => setMinutes(Number(e.target.value))} className="u-border-none">
                        {MINUTES.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.text}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="flexWidget__body">
                    <h1 className="u-mt-0 u-mb-md">{sessions.length}</h1>
                    <UserSessions sessions={sessions} />
                </div>
            </div>
        </div>
    );
}

function useUserSessions(minutes) {
    const query = useQuery({
        queryKey: ["admin", "user-sessions", minutes],
        queryFn: async () => httpClient.get(`admin/userSessions/${minutes}`),
        refetchInterval: 10000,
        retry: false,
    });

    return query.data ?? [];
}

const MINUTES = [
    { value: 5, text: "Last 5 mins" },
    { value: 30, text: "Last 30 mins" },
    { value: 60, text: "Last hour" },
];
